import React, { FC } from 'react';
import { CircularProgress } from '@mui/material';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import { sxPropsByVariantsProps } from '../Button2';


interface SizeProps {
    size?: 'extraExtraLarge' | 'extraLarge' | 'large' | 'medium' | 'small' | 'extraSmall';
}

interface VariantsProps {
    variantType?: 'main' | 'brand';
    variant?: 'primary' | 'secondary' | 'stroke';
}

const iconPForSize: Record<SizeProps['size'], number> = {
    extraExtraLarge: 4,
    extraLarge: 3,
    large: 2.5,
    medium: 2,
    small: 2,
    extraSmall: 1,
};

const iconSizeForSize: Record<SizeProps['size'], number> = {
    extraExtraLarge: 6,
    extraLarge: 6,
    large: 5,
    medium: 5,
    small: 4,
    extraSmall: 4,
};

interface IconProps {
    isRound?: boolean;
}

export interface IconButtonProps extends
    VariantsProps,
    SizeProps,
    IconProps,
    Omit<LoadingButtonProps, 'color' | 'size' | 'variant'> { }

export const IconButton: FC<IconButtonProps> = React.forwardRef(({
    size = 'medium',
    variantType = 'main',
    variant = 'primary',
    isRound,
    sx,
    ...props
}, ref) => (
    <LoadingButton
        onMouseUp={e => e.currentTarget.blur()}
        ref={ref}
        sx={[
            {
                minWidth: 'auto',
                p: iconPForSize[size],

                borderRadius: isRound ? 7 : 2.5,

                '& svg': ({ spacing }) => ({
                    width: spacing(iconSizeForSize[size]),
                    height: spacing(iconSizeForSize[size]),
                }),
                ...sxPropsByVariantsProps[variantType][variant],
            },
            ...Array.isArray(sx) ? sx : [sx],
        ]}
        loadingIndicator={(
            <CircularProgress
                color='inherit'
                size='auto'
            />
        )}
        {...props}
    />
));
